import React from 'react';
import './WorkForce.css';

const WorkForce = () => {
  return (
    <div className="work-force-page">
      <section className="wf-hero">
        <div className="wf-hero-bg"></div>
        <div className="wf-hero-grid"></div>
        <div className="wf-hero-watermark">KP</div>
        <div className="wf-hero-slash"></div>
        <div className="wf-hero-slash2"></div>
        <div className="wf-dots">
          <span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span>
          <span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span>
          <span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span>
          <span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span>
        </div>

        <div className="wf-hero-content">
          <div className="wf-hero-left">
            <div className="wf-hero-eyebrow">
              <div className="wf-hero-eyebrow-dot"></div>
              <span>Workforce Solutions Division</span>
            </div>
            <h1 className="wf-hero-headline">
              BUILDING<br />
              <span className="line2">India&apos;s</span>
              <span className="line3">WORKFORCE SOLUTIONS FUTURE</span>
            </h1>
            <p className="wf-hero-body">
              From the factory floor to the boardroom corridor — Krishpar Technologies bridges the gap between raw human potential and organisational excellence. We don&apos;t just place people. <strong>We engineer workforces</strong> that drive industries forward with precision, compliance, and lasting purpose.
            </p>
            <div className="hero-stats">
              <div className="hero-stat">
                <div className="hero-stat-num">5000+</div>
                <div className="hero-stat-label">Workers Deployed</div>
              </div>
              <div className="hero-stat">
                <div className="hero-stat-num">200+</div>
                <div className="hero-stat-label">Employer Partners</div>
              </div>
              <div className="hero-stat">
                <div className="hero-stat-num">PAN</div>
                <div className="hero-stat-label">India Network</div>
              </div>
            </div>
          </div>

          <div className="hero-right">
            <div className="service-constellation">

              {/* SVG connector lines */}
              <svg className="connector-svg" viewBox="0 0 460 460">
                <line x1="230" y1="230" x2="230" y2="36" stroke="rgba(120,190,32,0.25)" strokeWidth="1.5" strokeDasharray="6 4" />
                <line x1="230" y1="230" x2="408" y2="138" stroke="rgba(120,190,32,0.25)" strokeWidth="1.5" strokeDasharray="6 4" />
                <line x1="230" y1="230" x2="408" y2="322" stroke="rgba(120,190,32,0.25)" strokeWidth="1.5" strokeDasharray="6 4" />
                <line x1="230" y1="230" x2="230" y2="424" stroke="rgba(120,190,32,0.25)" strokeWidth="1.5" strokeDasharray="6 4" />
                <line x1="230" y1="230" x2="52" y2="322" stroke="rgba(120,190,32,0.25)" strokeWidth="1.5" strokeDasharray="6 4" />
                <line x1="230" y1="230" x2="52" y2="138" stroke="rgba(120,190,32,0.25)" strokeWidth="1.5" strokeDasharray="6 4" />
              </svg>

              <div className="orbit-ring orbit-ring-1"></div>
              <div className="orbit-ring orbit-ring-2"></div>

              <div className="constellation-center">
                <div className="constellation-center-label">WORK<br />FORCE</div>
              </div>

              <div className="snode snode-1">
                <div className="snode-circle"><span className="snode-icon">🦺</span></div>
                <div className="snode-label">Blue Collar Hiring</div>
              </div>
              <div className="snode snode-2">
                <div className="snode-circle"><span className="snode-icon">👔</span></div>
                <div className="snode-label">Grey Collar Hiring</div>
              </div>
              <div className="snode snode-3">
                <div className="snode-circle"><span className="snode-icon">🎓</span></div>
                <div className="snode-label">Apprenticeship</div>
              </div>
              <div className="snode snode-4">
                <div className="snode-circle"><span className="snode-icon">🏛️</span></div>
                <div className="snode-label">NAPS Scheme</div>
              </div>
              <div className="snode snode-5">
                <div className="snode-circle"><span className="snode-icon">📋</span></div>
                <div className="snode-label">NATS Program</div>
              </div>
              <div className="snode snode-6">
                <div className="snode-circle"><span className="snode-icon">⚙️</span></div>
                <div className="snode-label">Payroll & Compliance</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION INTRO */}
      <div className="wf-section-intro">
        <div>
          <div className="wf-section-label">
            <div className="section-label-line"></div>
            <span>What We Do</span>
          </div>
          <h2 className="section-h2">
            People are the<br />
            <span className="green">engine</span> of <em>every</em>
            <br />
            industry.
          </h2>
        </div>
        <div className="intro-right">
          <p>
            At Krishpar Technologies, we understand that the most sophisticated machinery, the most advanced technology, and the most ambitious strategies are only as powerful as the people behind them. Our Workforce Solutions practice was built on a single conviction — <strong>every role matters, and every person deserves to be matched with purpose.</strong>
          </p>
          <p>
            Whether you are an industry titan scaling operations across states or a growing enterprise building your first structured team — we architect your workforce from the ground up. We bring together decades of domain expertise, a robust pan-India talent network, and deep compliance knowledge to deliver workforce solutions that are not just fast, but <strong>fundamentally right.</strong>
          </p>
          <p>
            From unskilled labour to skilled technicians, from shop-floor apprentices to mid-management supervisors — Krishpar is your single-window partner across the entire workforce spectrum. Our solutions are built around India&apos;s evolving labour laws, government skilling initiatives, and the realities of today&apos;s hiring landscape.
          </p>
        </div>
      </div>

      {/* SERVICES SECTION */}
      <section className="services-section">
        <div className="services-header">
          <div className="wf-section-label">
            <div className="section-label-line"></div>
            <span>Our Services</span>
          </div>
          <h2 className="section-h2">Every collar.<br /><span className="green">One partner.</span></h2>
        </div>

        {/* SERVICE 1: BLUE COLLAR */}
        <div className="service-block">
          <div className="service-visual">
            <div className="service-visual-card">
              <div className="svc-card-pattern"></div>
              <span className="svc-big-icon">🦺</span>
              <div>
                <div className="svc-card-title">Blue Collar<br /><span>Workforce Solutions Hiring</span></div>
                <div className="svc-card-desc">Skilled, semi-skilled, and unskilled talent for manufacturing, logistics, construction, and industrial operations across India.</div>
              </div>
              <div className="svc-tags">
                <span className="svc-tag">Verified Talent</span>
                <span className="svc-tag">Background Screened</span>
                <span className="svc-tag">Ready to Deploy</span>
                <span className="svc-tag">Contractual &amp; Permanent</span>
              </div>
            </div>
          </div>
          <div className="service-text">
            <span className="svc-number">01</span>
            <h3 className="svc-title">Blue Collar<br /><span>Hiring</span></h3>
            <div className="svc-subtitle">Unskilled · Semi-Skilled · Skilled Industrial Workforce Solutions</div>
            <p className="svc-body">
              The backbone of India&apos;s industrial economy wears a hard hat, safety boots, and a work ethic that no machine can replicate. Krishpar&apos;s Blue Collar Hiring vertical is built to source, screen, and deploy <strong>field-ready talent at scale</strong> — from a single urgently needed technician to an entire workforce for a greenfield plant.
            </p>
            <p className="svc-body">
              We maintain an active, geo-tagged talent pool spanning fabricators, welders, electricians, machine operators, production workers, helpers, loaders, drivers, and security personnel. Every candidate in our network undergoes a structured evaluation covering <strong>skill proficiency, background verification, health fitness, and document compliance</strong> — so your hiring is never a leap of faith.
            </p>
            <ul className="feature-list">
              <li><div><strong>Pan-India Sourcing Network</strong> — Active talent pools across industrial corridors including Chennai, Pune, Surat, Ludhiana, Hyderabad, and beyond.</div></li>
              <li><div><strong>Contract &amp; Permanent Staffing</strong> — Flexible engagement models aligned to your operational cadence, seasonal surges, and budget.</div></li>
              <li><div><strong>Compliance-First Deployment</strong> — PF, ESIC, statutory bonus, gratuity, and all labour law obligations managed end-to-end.</div></li>
              <li><div><strong>On-site Mobilisation Support</strong> — We don&apos;t just source — we mobilise, onboard, and hand over workforce that is ready on Day 1.</div></li>
              <li><div><strong>Replacement Guarantee</strong> — Zero-disruption assurance with structured replacement timelines for early attrition.</div></li>
            </ul>
          </div>
        </div>

        {/* SERVICE 2: GREY COLLAR */}
        <div className="service-block reverse">
          <div className="service-visual">
            <div className="service-visual-card green-accent">
              <div className="svc-card-pattern"></div>
              <span className="svc-big-icon">👔</span>
              <div>
                <div className="svc-card-title">Grey Collar<br /><span>Workforce Solutions Hiring</span></div>
                <div className="svc-card-desc">Mid-level supervisors, team leads, technicians, and specialised operators bridging the gap between operations and management.</div>
              </div>
              <div className="svc-tags">
                <span className="svc-tag">Supervisory Roles</span>
                <span className="svc-tag">ITI / Diploma Holders</span>
                <span className="svc-tag">Technical Experts</span>
                <span className="svc-tag">Proven Leaders</span>
              </div>
            </div>
          </div>
          <div className="service-text">
            <span className="svc-number">02</span>
            <h3 className="svc-title">Grey Collar<br /><span>Hiring</span></h3>
            <div className="svc-subtitle">Supervisors · Technicians · Foremen · Mid-Level Operations</div>
            <p className="svc-body">
              In the complex ecosystem of modern industry, the most critical — and most overlooked — talent layer is the one that connects shop-floor workers to senior management. Grey collar professionals are <strong>the force multipliers</strong> of any operation: the foreman who ensures production targets are met, the quality controller who keeps standards uncompromised, and the maintenance technician who prevents a costly shutdown.
            </p>
            <p className="svc-body">
              Krishpar specialises in identifying, assessing, and placing grey collar talent with a depth that generalist recruiters cannot match. We evaluate not just technical credentials but also <strong>leadership capability, process awareness, and the ability to operate under pressure</strong> — because these roles demand more than a qualification; they demand character.
            </p>
            <ul className="feature-list">
              <li><div><strong>Role-Specific Competency Assessment</strong> — Domain-aligned technical tests, situational judgment evaluation, and structured interviews.</div></li>
              <li><div><strong>ITI / Diploma / B.Tech Screening</strong> — Qualification-verified profiles with hands-on experience validation.</div></li>
              <li><div><strong>Supervisory Readiness Scoring</strong> — Proprietary evaluation to assess supervisory maturity and team-handling capability.</div></li>
              <li><div><strong>Industry-Domain Expertise</strong> — Dedicated talent pools for auto components, textiles, pharma, FMCG, steel, and more.</div></li>
              <li><div><strong>Induction &amp; Handover Support</strong> — Structured onboarding documentation and probation monitoring for critical roles.</div></li>
            </ul>
          </div>
        </div>

        {/* SERVICE 3: APPRENTICESHIP */}
        <div className="service-block">
          <div className="service-visual">
            <div className="service-visual-card">
              <div className="svc-card-pattern"></div>
              <span className="svc-big-icon">🎓</span>
              <div>
                <div className="svc-card-title">Apprenticeship<br /><span>Program Design</span></div>
                <div className="svc-card-desc">Structured apprenticeship programme design, management, and compliance — transforming fresh talent into industry-ready professionals.</div>
              </div>
              <div className="svc-tags">
                <span className="svc-tag">End-to-End Managed</span>
                <span className="svc-tag">Govt. Compliant</span>
                <span className="svc-tag">Stipend Managed</span>
                <span className="svc-tag">Skill Certification</span>
              </div>
            </div>
          </div>
          <div className="service-text">
            <span className="svc-number">03</span>
            <h3 className="svc-title">Apprenticeship<br /><span>Programs</span></h3>
            <div className="svc-subtitle">Structured Skill Development · Industry-Academia Bridge</div>
            <p className="svc-body">
              Apprenticeship is not just a cost-effective staffing strategy — it is the most powerful talent pipeline you can build. When done right, it creates workers who are <strong>shaped by your processes, committed to your culture, and trained to your exact standards</strong>. Krishpar designs and manages apprenticeship programmes that are fully compliant with the Apprentices Act, 1961 and its amendments.
            </p>
            <p className="svc-body">
              We work with your production, HR, and training teams to architect a programme that runs in parallel to your operations — delivering <strong>measurable productivity from Day 1</strong> while simultaneously developing the next generation of your core workforce. From sourcing candidates and completing government registrations to managing stipend disbursements and tracking attendance — Krishpar handles every layer so you focus on what you do best.
            </p>
            <ul className="feature-list">
              <li><div><strong>Programme Architecture</strong> — Trade selection, curriculum mapping, and on-the-job training schedule designed in consultation with your operations team.</div></li>
              <li><div><strong>Government Registration &amp; Compliance</strong> — Complete handling of apprenticeship registration, reporting, and statutory requirements.</div></li>
              <li><div><strong>Stipend Management</strong> — Timely stipend processing, attendance tracking, and payroll integration for apprentices.</div></li>
              <li><div><strong>Assessment &amp; Certification</strong> — Periodic skill assessments and final certification aligned to National Skill Qualification Framework.</div></li>
              <li><div><strong>Post-Programme Placement</strong> — Conversion pathways to permanent employment for high-performing apprentices.</div></li>
            </ul>
          </div>
        </div>
      </section>

      {/* GOVERNMENT SKILLING INITIATIVES */}
      <section id="govt">
        <div className="govt-section">
          <div className="section-label" style={{ justifyContent: 'start' }}>
            <span>Government Skilling Initiatives</span>
          </div>
          <h2 className="section-h2">Unlocking India&apos;s<br />skilling <span className="green">ecosystem.</span></h2>

          <div className="govt-grid">

            {/* NAPS */}
            <div className="govt-card">
              <div className="govt-card-bg-text">NAPS</div>
              <div className="govt-card-badge">Active Scheme</div>
              <div className="govt-card-name">NAPS</div>
              <div className="govt-card-full">National Apprenticeship Promotion Scheme — Ministry of Skill Development &amp; Entrepreneurship</div>
              <p className="govt-card-body">
                NAPS is the Government of India&apos;s flagship initiative to promote apprenticeship training across industries by sharing the financial burden of training with employers. Krishpar acts as your NAPS implementation partner — handling everything from establishing your organisation on the apprenticeship portal, to candidate enrolment, contract generation, claim filing, and reimbursement tracking.
              </p>
              <p className="govt-card-body">
                We ensure your organisation capitalises on every benefit government support offers without the administrative burden — so you can focus on building a skilled workforce while we manage the compliance machinery behind it.
              </p>
              <div className="govt-feature">
                <div className="govt-feat-item">
                  <div className="govt-feat-icon">💰</div>
                  Government reimbursement benefits claimed and tracked on your behalf
                </div>
                <div className="govt-feat-item">
                  <div className="govt-feat-icon">📄</div>
                  Complete portal registration and contract management by Krishpar
                </div>
                <div className="govt-feat-item">
                  <div className="govt-feat-icon">🏛️</div>
                  Applicable across both fresher and graduate-level apprenticeship programmes
                </div>
              </div>
            </div>

            {/* NATS */}
            <div className="govt-card alt-card">
              <div className="govt-card-bg-text">NATS</div>
              <div className="govt-card-badge" style={{ background: 'var(--dark)', color: 'var(--white)' }}>Active Scheme</div>
              <div className="govt-card-name">NATS</div>
              <div className="govt-card-full">National Apprenticeship Training Scheme</div>
              <p className="govt-card-body">
                The National Apprenticeship Training Scheme (NATS) enables organizations to engage fresh graduates and diploma holders through structured apprenticeship training governed by BOAT/RDAT authorities. The scheme ensures practical skill development while allowing employers to build a pipeline of industry-ready talent with government-supported stipends.
              </p>
              <p className="govt-card-body">
                Krishpar Technologies simplifies the end-to-end NATS process &mdash; from candidate onboarding and contract registration to compliance management and coordination with regional authorities. We ensure every apprentice engagement is aligned with regulatory guidelines, eliminating operational complexity and compliance risks.
              </p>
              <div className="govt-feature">
                <div className="govt-feat-item">
                  <div className="govt-feat-icon">🎯</div>
                  Graduate and diploma apprentices aligned to industry-specific roles
                </div>
                <div className="govt-feat-item">
                  <div className="govt-feat-icon">🔗</div>
                  End-to-end coordination with BOAT / RDAT handled by Krishpar
                </div>
                <div className="govt-feat-item">
                  <div className="govt-feat-icon">📊</div>
                  Apprentice tracking including attendance, assessments, and progress
                </div>
                <div className="govt-feat-item">
                  <div className="govt-feat-icon">🛡️</div>
                  Full compliance management with zero-penalty assurance
                </div>
                <div className="govt-feat-item">
                  <div className="govt-feat-icon">👥</div>
                  Dedicated HR compliance support and documentation
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* WHY KRISHPAR SECTION */}
      <section className="wf-why-section">
        <div className="why-inner">
          <div className="section-label" style={{ justifyContent: 'start' }}>
            <span style={{ color: 'var(--green)' }}>The Krishpar Difference</span>
          </div>
          <h2 className="section-h2" style={{ color: 'white' }}>Why organisations<br />choose <span className="green">Krishpar</span><br />again and again.</h2>
          <div className="wf-why-grid">
            <div className="wf-why-card">
              <div className="why-card-num">01 /</div>
              <span className="why-card-icon">🔍</span>
              <div className="why-card-title">Depth of<br />Understanding</div>
              <p className="why-card-body">We don&apos;t recruit generically. Our teams are industry-aligned — which means when we source a machine operator for an auto components plant, we understand gear tolerances, shift cycles, and what separates an average operator from an exceptional one. This domain depth shows in the quality of every deployment.</p>
            </div>
            <div className="wf-why-card">
              <div className="why-card-num">02 /</div>
              <span className="why-card-icon">⚖️</span>
              <div className="why-card-title">Compliance<br />Without Compromise</div>
              <p className="why-card-body">Labour law in India is intricate, evolving, and unforgiving of negligence. Krishpar&apos;s compliance practice ensures every worker we deploy is covered under PF, ESIC, and all applicable statutory obligations — protecting your organisation from risk while ensuring workers receive every benefit they are legally entitled to.</p>
            </div>
            <div className="wf-why-card">
              <div className="why-card-num">03 /</div>
              <span className="why-card-icon">🌐</span>
              <div className="why-card-title">Pan-India<br />Reach</div>
              <p className="why-card-body">Talent exists everywhere — our network ensures we can reach it. From metropolitan industrial zones to Tier 3 towns with strong ITI ecosystems, Krishpar&apos;s sourcing infrastructure spans the width of India — giving you access to talent pools that other partners simply cannot tap.</p>
            </div>
            <div className="wf-why-card">
              <div className="why-card-num">04 /</div>
              <span className="why-card-icon">🤝</span>
              <div className="why-card-title">Partnership,<br />Not Transactions</div>
              <p className="why-card-body">We measure our success by your workforce&apos;s performance — not by the number of CVs we send. Our account management model assigns dedicated relationship managers who understand your operations, monitor deployment health, and proactively address challenges before they become problems.</p>
            </div>
            <div className="wf-why-card">
              <div className="why-card-num">05 /</div>
              <span className="why-card-icon">🚀</span>
              <div className="why-card-title">Speed Without<br />Sacrificing Quality</div>
              <p className="why-card-body">We know that a vacancy in a production line costs money every hour it stays open. Our pre-built talent pipelines and rapid mobilisation capabilities ensure that urgency never forces you to compromise on the quality of hire. We are built for the pace of industry.</p>
            </div>
            <div className="wf-why-card">
              <div className="why-card-num">06 /</div>
              <span className="why-card-icon">🎓</span>
              <div className="why-card-title">Government Scheme<br />Navigation</div>
              <p className="why-card-body">NAPS, NATS, apprenticeship registrations, BOAT compliance — government&apos;s skilling ecosystem is a powerful resource that most companies leave on the table due to complexity. Krishpar&apos;s specialists ensure you extract every benefit these schemes offer, compliantly and efficiently.</p>
            </div>
            <div className="wf-why-card">
              <div className="why-card-num">07 /</div>
              <span className="why-card-icon">📈</span>
              <div className="why-card-title">Long-Term<br />Workforce Planning</div>
              <p className="why-card-body">Beyond immediate hiring, Krishpar works with clients on workforce demand forecasting, retention strategy, and multi-year talent pipeline development — ensuring that today&apos;s hires become tomorrow&apos;s skilled core workforce and not a revolving door of attrition.</p>
            </div>
            <div className="wf-why-card">
              <div className="why-card-num">08 /</div>
              <span className="why-card-icon">📱</span>
              <div className="why-card-title">Technology-<br />Driven Operations</div>
              <p className="why-card-body">From digital onboarding to attendance management dashboards, Krishpar leverages technology to make workforce management transparent, traceable, and real-time. Clients receive regular reporting on deployment status, compliance milestones, and workforce analytics.</p>
            </div>
          </div>
        </div>
      </section>

      {/* HOW WE WORK PROCESS SECTION */}
      <section id="process">
        <div className="wf-process-section">
          <div className="section-label" style={{justifyContent:'start'}}>
            <span>How We Work</span>
          </div>
          <h2 className="section-h2">A process as<br/>structured as<br/><span className="green">your operations.</span></h2>

          <div className="process-flow">
            <div className="process-step">
              <div className="process-step-circle"><span className="process-step-icon">🎯</span></div>
              <div className="process-step-title">Understand &amp; Define</div>
              <p className="process-step-body">Deep-dive into your workforce requirement — role, skill level, volumes, timelines, compliance expectations, and cultural fit criteria.</p>
            </div>
            <div className="process-step">
              <div className="process-step-circle"><span className="process-step-icon">🔍</span></div>
              <div className="process-step-title">Source &amp; Screen</div>
              <p className="process-step-body">Activate our network, advertise strategically, and run multi-stage screening — skills test, background check, health check, and document verification.</p>
            </div>
            <div className="process-step">
              <div className="process-step-circle"><span className="process-step-icon">📋</span></div>
              <div className="process-step-title">Shortlist &amp; Present</div>
              <p className="process-step-body">Deliver a curated shortlist with complete candidate dossiers — evaluation scores, background reports, availability, and our recommendation rationale.</p>
            </div>
            <div className="process-step">
              <div className="process-step-circle"><span className="process-step-icon">✅</span></div>
              <div className="process-step-title">Select &amp; Onboard</div>
              <p className="process-step-body">Coordinate client interviews, manage offer, complete joining formalities, statutory registrations, and structured onboarding for every selected candidate.</p>
            </div>
            <div className="process-step">
              <div className="process-step-circle"><span className="process-step-icon">📊</span></div>
              <div className="process-step-title">Manage &amp; Monitor</div>
              <p className="process-step-body">Post-deployment tracking, compliance management, payroll processing, and regular workforce health reviews to ensure sustained productivity and satisfaction.</p>
            </div>
          </div>
        </div>
      </section>

      {/* INDUSTRIES WE SERVE SECTION */}
      <section className="industries-section" id="industries">
        <div className="industries-inner">
          <div className="section-label" style={{justifyContent:'start'}}>
            <span>Industries We Serve</span>
          </div>
          <h2 className="section-h2">Where our<br/>workforce <span className="green">works.</span></h2>
          <div className="industries-grid">
            <div className="wf-industry-chip"><span className="industry-chip-icon">🚗</span><div className="industry-chip-name">Automotive &amp; Auto Components</div></div>
            <div className="wf-industry-chip"><span className="industry-chip-icon">🏭</span><div className="industry-chip-name">Manufacturing &amp; Engineering</div></div>
            <div className="wf-industry-chip"><span className="industry-chip-icon">🔧</span><div className="industry-chip-name">Heavy Industries &amp; Steel</div></div>
            <div className="wf-industry-chip"><span className="industry-chip-icon">💊</span><div className="industry-chip-name">Pharmaceuticals &amp; Life Sciences</div></div>
            <div className="wf-industry-chip"><span className="industry-chip-icon">📦</span><div className="industry-chip-name">Logistics &amp; Warehousing</div></div>
            <div className="wf-industry-chip"><span className="industry-chip-icon">🏗️</span><div className="industry-chip-name">Infrastructure &amp; Construction</div></div>
            <div className="wf-industry-chip"><span className="industry-chip-icon">🍽️</span><div className="industry-chip-name">FMCG &amp; Food Processing</div></div>
            <div className="wf-industry-chip"><span className="industry-chip-icon">⚡</span><div className="industry-chip-name">Electrical &amp; Electronics</div></div>
            <div className="wf-industry-chip"><span className="industry-chip-icon">🧵</span><div className="industry-chip-name">Textiles &amp; Apparel</div></div>
            <div className="wf-industry-chip"><span className="industry-chip-icon">🏢</span><div className="industry-chip-name">Facilities Management</div></div>
            <div className="wf-industry-chip"><span className="industry-chip-icon">♻️</span><div className="industry-chip-name">Energy &amp; Renewables</div></div>
            <div className="wf-industry-chip"><span className="industry-chip-icon">🖥️</span><div className="industry-chip-name">IT &amp; ITeS Field Ops</div></div>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      {/* <section className="cta-section" id="contact">
        <div className="cta-inner">
          <div className="section-label" style={{justifyContent:'center', marginBottom:'16px'}}>
            <span>Let&apos;s Build Together</span>
          </div>
          <h2 className="cta-headline">Your workforce<br/><span>challenge starts</span><br/>here.</h2>
          <p className="cta-body">Tell us what you need — and Krishpar&apos;s workforce specialists will come back to you with a solution that is tailored, compliant, and built to last. No generic proposals. No one-size-fits-all answers.</p>
          <div className="cta-buttons">
            <a href="mailto:connect@krishpar.com" className="btn-primary">Talk to Our Team</a>
            <a href="#services" className="btn-secondary">Explore Services</a>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default WorkForce;
